webpackJsonp([114276838955818,60335399758886],{

/***/ 106:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Hatch tech blog"}},"tagPages":{"edges":[{"node":{"id":"SitePage /tags/blog/","path":"/tags/blog/","context":{"category":null}}},{"node":{"id":"SitePage /tags/gatsby/","path":"/tags/gatsby/","context":{"category":null}}},{"node":{"id":"SitePage /tags/java-script/","path":"/tags/java-script/","context":{"category":null}}},{"node":{"id":"SitePage /tags/react/","path":"/tags/react/","context":{"category":null}}},{"node":{"id":"SitePage /tags/redux/","path":"/tags/redux/","context":{"category":null}}},{"node":{"id":"SitePage /tags/python/","path":"/tags/python/","context":{"category":null}}},{"node":{"id":"SitePage /tags/meta-programming/","path":"/tags/meta-programming/","context":{"category":null}}},{"node":{"id":"SitePage /tags/vim/","path":"/tags/vim/","context":{"category":null}}},{"node":{"id":"SitePage /tags/async-await/","path":"/tags/async-await/","context":{"category":null}}},{"node":{"id":"SitePage /tags/react-native/","path":"/tags/react-native/","context":{"category":null}}},{"node":{"id":"SitePage /tags/json-rpc/","path":"/tags/json-rpc/","context":{"category":null}}},{"node":{"id":"SitePage /tags/async/","path":"/tags/async/","context":{"category":null}}},{"node":{"id":"SitePage /tags/type-script/","path":"/tags/type-script/","context":{"category":null}}}]},"categoryPages":{"edges":[{"node":{"id":"SitePage /categories/gatsby/","path":"/categories/gatsby/","context":{"category":"Gatsby"}}},{"node":{"id":"SitePage /categories/front-end/","path":"/categories/front-end/","context":{"category":"FrontEnd"}}},{"node":{"id":"SitePage /categories/python/","path":"/categories/python/","context":{"category":"Python"}}},{"node":{"id":"SitePage /categories/vim/","path":"/categories/vim/","context":{"category":"Vim"}}},{"node":{"id":"SitePage /categories/mobile-app/","path":"/categories/mobile-app/","context":{"category":"MobileApp"}}},{"node":{"id":"SitePage /categories/web/","path":"/categories/web/","context":{"category":"Web"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(252);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(106);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Footer;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(43);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _github = __webpack_require__(549);
	
	var _github2 = _interopRequireDefault(_github);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'footer', role: 'contentinfo' },
	    _react2.default.createElement(
	      'div',
	      { className: 'footer__inner' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'footer__title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            style: {
	              boxShadow: 'none',
	              textDecoration: 'none',
	              color: 'inherit'
	            },
	            to: '/'
	          },
	          'Hatch tech blog'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'copyright' },
	        'Copyright \xA9 2017. Ogura Daiki'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/hachibeeDI/hachibeeDI.github.io', rel: 'noopener noreferrer' },
	        _react2.default.createElement('i', { className: 'footer-icon-github', style: { backgroundImage: 'url(' + _github2.default + ')' } })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	__webpack_require__(339);
	
	__webpack_require__(443);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(43);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _footer = __webpack_require__(250);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$PureComponent) {
	  _inherits(Template, _React$PureComponent);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children,
	        data = _props.data;
	
	
	    var rootPath = '/';
	    if (true) {
	      rootPath = ("") + '/';
	    }
	
	    var header = void 0;
	    if (location.pathname === rootPath) {
	      header = _react2.default.createElement(
	        'h1',
	        { className: 'blog-title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            style: {
	              boxShadow: 'none',
	              textDecoration: 'none',
	              color: 'inherit'
	            },
	            to: '/'
	          },
	          data.site.siteMetadata.title
	        )
	      );
	    } else {
	      header = _react2.default.createElement(
	        'h3',
	        {
	          style: {
	            margin: 0
	          }
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            style: {
	              boxShadow: 'none',
	              textDecoration: 'none',
	              color: 'inherit'
	            },
	            to: '/'
	          },
	          data.site.siteMetadata.title
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'container' },
	      _react2.default.createElement(
	        'header',
	        { className: 'main-header', role: 'banner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-header__inner' },
	          header
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'main-section' },
	        children()
	      ),
	      _react2.default.createElement(_footer2.default, { categories: data.categoryPages.edges, tags: data.tagPages.edges })
	    );
	  };
	
	  return Template;
	}(_react2.default.PureComponent);
	
	exports.default = Template;
	
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func,
	  location: _react2.default.PropTypes.object,
	  route: _react2.default.PropTypes.object
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgYXJpYS1sYWJlbGxlZGJ5PSJ0aXRsZSIKYXJpYS1kZXNjcmliZWRieT0iZGVzYyIgcm9sZT0iaW1nIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPHRpdGxlPkdpdGh1YjwvdGl0bGU+CiAgPGRlc2M+QSBsaW5lIHN0eWxlZCBpY29uIGZyb20gT3Jpb24gSWNvbiBMaWJyYXJ5LjwvZGVzYz4KICA8cGF0aCBkYXRhLW5hbWU9ImxheWVyMSIKICBkPSJNMzIgMS45NTJhMzAuMDE5IDMwLjAxOSAwIDAgMC05LjQ2OSA1OC41YzEuNS4yODEgMi4wNjMtLjY1NiAyLjA2My0xLjQwNnYtNS42MjVjLTguMzQ0IDEuNzc5LTEwLjEyNS0zLjU2My0xMC4xMjUtMy41NjMtMS40MDYtMy40NjktMy4zNzUtNC40MDYtMy4zNzUtNC40MDYtMi43MTktMS44NzUuMTg3LTEuNzgxLjE4Ny0xLjc4MSAzIC4xODggNC41OTQgMy4wOTQgNC41OTQgMy4wOTQgMi43MTkgNC41OTQgNy4wMzEgMy4yODEgOC43MTkgMi41MzFhNi41IDYuNSAwIDAgMSAxLjg3NS00LjAzMWMtNi42NTYtLjc1LTEzLjY4OC0zLjM3NS0xMy42ODgtMTQuODEyYTExLjUgMTEuNSAwIDAgMSAzLjA5NC04LjA2MyAxMS4yMTcgMTEuMjE3IDAgMCAxIC4yODEtNy45NjlzMi41MzEtLjg0NCA4LjI1IDMuMDk0YTI4Ljk0NCAyOC45NDQgMCAwIDEgNy41LTEuMDMxIDI4LjQgMjguNCAwIDAgMSA3LjUgMS4wMzFjNS43MTktMy44NDQgOC4yNS0zLjA5NCA4LjI1LTMuMDk0YTExLjIxNyAxMS4yMTcgMCAwIDEgLjI4MSA3Ljk2OSAxMS4zNCAxMS4zNCAwIDAgMSAzLjA5NCA4LjA2M2MwIDExLjUzMS03LjAzMSAxNC4wNjMtMTMuNjg4IDE0LjgxM2E3LjI2MiA3LjI2MiAwIDAgMSAyLjA2MyA1LjUzNHY4LjI1YzAgLjg0NC41NjIgMS42ODcgMi4wNjMgMS40MDZBMzAuMDE5IDMwLjAxOSAwIDAgMCAzMiAxLjk1MnoiCiAgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIKICBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-42968e6cabcb64593260.js